import { useMemo } from 'react';

import { usePageInfo } from '@confluence/page-info';

/** Checks whether the current user can edit restrictions for the current page. */
export const useCanEditPageRestrictions = (): boolean => {
	const { pageInfo } = usePageInfo();

	const canEditPageRestrictions: boolean = useMemo(() => {
		if (pageInfo) {
			const pageType = pageInfo.type ?? '';
			const operations = pageInfo.operations || [];
			const userCanEditRestrictions = operations.some(
				(o) => o?.operation === 'restrict_content' && o?.targetType === pageType,
			);

			return userCanEditRestrictions;
		}

		return false;
	}, [pageInfo]);

	return canEditPageRestrictions;
};
